import React, { useEffect } from "react";
import Main from "../../../Main/Main";
import Tabs from "../../Tabs/Tabs";
import Details from "../../Details/Details";
import DetailsData from "./DetailsEducationData";
function Education({ title }) {
  useEffect(() => {
    document.title = title;
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, [title]);
  return (
    <div>
      <Main
        heading="EDUCATION"
        description="E-Learning Opportunities for Brighter Tomorrow"
      />
      <Tabs active="6" />
      <Details data={DetailsData} />
    </div>
  );
}

export default Education;
